import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderKnowingGod from "../../../../src/content/knowinggodthroughhisword/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderKnowingGod,
  React
};